/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export const CaretDirection = {
  UP: "up",
  DOWN: "down",
  LEFT: "left",
  RIGHT: "right"
} as const;

export type CaretDirection =
  (typeof CaretDirection)[keyof typeof CaretDirection];

export interface CaretProps {
  /** Which edge of a scrollable region this caret points toward. */
  direction: CaretDirection;
  /** Whether the caret is disabled (no more content in that direction). */
  isDisabled: boolean;
  /** Click handler to scroll the associated list/grid/carousel. */
  onClick: () => void;
  /** Optional extra class name, used by the consuming screen for positioning. */
  className?: string;
  /**
   * VoiceView: true hides this pointer-only control from the screen reader
   * (aria-hidden, out of the tab order). Pointer clicks still work.
   */
  hideFromScreenReader?: boolean;
  /** Optional hover handlers. */
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}
